import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";

import { downloadFileHandler } from "~/utils/fileUtils";
import CustomeButton from "~/components/Button";
import FileIcon from "~/components/file-type-icon";
import Categories from "~/components/Processes/conversations/utils/categories.json";
import AdminOnly from "~/components/AdminOnly";
import { useSelector } from "react-redux";

import fileUploadLogo from "../../../assets/attachment-paperclip.svg";
import DocumentDescription from "~/components/document-description";
import { useParams } from "react-router-dom";

const CoreEntityAttachmentTable = ({
  loading,
  page,
  rows,
  first,
  totalRecords,
  onPageChange,
  isDataAvailable,
  attachments,
  setOpenDialog,

  handleAttachmentDelete,
}) => {
  const skeletonRows = [...Array(5)];
  const { id: userId, role } = useSelector((state) => state.login);
  const { id } = useParams();

  return (
    <div>
      {isDataAvailable ? (
        <DataTable
          value={loading ? skeletonRows : attachments}
          className="datatable-right-align"
          paginator={attachments?.length > 10}
          first={first}
          rows={rows}
          totalRecords={attachments?.length}
          onPage={onPageChange}
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No attachments found"
        >
          <Column
            header="Name"
            body={(field) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="file__name">
                  <FileIcon
                    filetype={field?.file_type}
                    filename={field?.name}
                    downloadFile={() =>
                      downloadFileHandler({
                        blob_url: field?.blob_url,
                        name: field?.name,
                      })
                    }
                  />
                </div>
              )
            }
          />
          <Column
            header="Category"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                Categories.find((c) => c.code === data.category)?.name
              )
            }
          />
          <Column
            header="Subcategory"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                Categories.find(
                  (c) => c.code === data.category,
                )?.subCategory?.find?.((s) => s.code === data.subCategory)?.name
              )
            }
          />
          <Column
            className="user_action--col"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <>
                  <div className="flex align-items-center">
                    <DocumentDescription
                      data={data}
                      id={id}
                      type="ENTITIES_PLUS"
                    />
                    <span
                      className="pi pi-download pencil-pointer"
                      onClick={() =>
                        downloadFileHandler({
                          blob_url: data?.blob_url,
                          name: data?.name,
                        })
                      }
                    ></span>
                    {(role === "GXM_ADMIN" || data.created_by === userId) && (
                      <span
                        className="pi pi-trash pencil-pointer"
                        onClick={() => handleAttachmentDelete(data)}
                      ></span>
                    )}
                  </div>
                </>
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <div className="no-documents-uploaded-section w-full">
            <img
              src={fileUploadLogo}
              alt="file-upload"
              className="file-upload-logo"
            />
            <p className="add-new-entity-heading mb-0">
              No Documents uploaded yet
            </p>
            <AdminOnly>
              <p className="drag-drop-text m-0">
                Upload supporting documents for this entity, such as Core Legal
                Documents
              </p>
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setOpenDialog(true)}
              />
            </AdminOnly>
          </div>
        </div>
      )}
    </div>
  );
};

export default CoreEntityAttachmentTable;
